/* eslint-disable eqeqeq */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Paper } from "@material-ui/core";
import {
    FilteringState,
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
} from "@devexpress/dx-react-grid";
import {
    Grid,
    PagingPanel,
    Table,
    TableFilterRow,
    TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

class R304PushNotificationTableComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSizes: [5, 10, 15, 20],
            defaultSorting: [],
            sortingStateColumnExtensions: [
                { columnName: "action", sortingEnabled: false },
            ],
            tableColumnExtensions: [
                { columnName: "title", wordWrapEnabled: true },
                { columnName: "body", wordWrapEnabled: true },
            ],
            filteringStateColumnExtensions: [
                { columnName: "action", filteringEnabled: false },
            ],
            defaultFilters: [],
        };
    }

    render() {
        const {
            pageSizes,
            defaultSorting,
            sortingStateColumnExtensions,
            filteringStateColumnExtensions,
            tableColumnExtensions,
            defaultFilters,
        } = this.state;

        const rows = this.props.data;
        const columns = this.props.columns;
        const showFilter = this.props.showFilter;

        return (
            <Paper>
                <Grid rows={rows} columns={columns}>
                    <FilteringState
                        defaultFilters={defaultFilters}
                        columnExtensions={filteringStateColumnExtensions}
                    />
                    <SortingState
                        defaultSorting={defaultSorting}
                        columnExtensions={sortingStateColumnExtensions}
                    />
                    <PagingState defaultCurrentPage={0} defaultPageSize={10} />
                    <IntegratedFiltering />
                    <IntegratedSorting />
                    <IntegratedPaging />
                    <Table columnExtensions={tableColumnExtensions} />
                    <TableHeaderRow
                        showSortingControls
                        titleComponent={(props) =>
                            props.children !== "Action" ? (
                                <b>{props.children}</b>
                            ) : (
                                <b>&emsp;{props.children}</b>
                            )
                        }
                    />
                    {showFilter && <TableFilterRow showFilterSelector />}
                    <PagingPanel pageSizes={pageSizes} />
                </Grid>
            </Paper>
        );
    }
}

R304PushNotificationTableComponent.propTypes = {
    showFilter: PropTypes.bool,
    data: PropTypes.array,
    columns: PropTypes.array,
};

R304PushNotificationTableComponent.defaultProps = {
    showFilter: false,
    data: [],
    columns: [],
};

export default R304PushNotificationTableComponent;